<div class = 'banner-wrapper'>
    <div class = 'background'>
        <ng-content></ng-content>
    </div>
</div>